// extracted by mini-css-extract-plugin
export var logo = "_lp-2";
export var logoWrapper = "_lp-1";
export var strip = "_lp-0";